import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';

@Component({
    selector: 'xqnr-question-delete',
    templateUrl: './question-delete.component.pug',
    styleUrls: ['./question-delete.component.scss'],
    standalone: false
})
export class QuestionDeleteComponent implements OnInit {
  @Input() questionId: string;
  @Output() questionDeleted = new EventEmitter();

  isDeleting = false;

  fa = {
    trash: faTrashAlt,
  };

  constructor(
    private qs: QuestionnaireService
  ) {}

  ngOnInit(): void {}

  removeQuestionSuccess = (data: any) => {
    this.isDeleting = false;
    this.questionDeleted.emit();
  };

  removeQuestionError = (err: any) => {
    this.isDeleting = false;
    console.error(err);
  };

  removeQuestion() {
    this.isDeleting = true;

    this.qs.deleteQuestion(this.questionId)
      .subscribe(this.removeQuestionSuccess, this.removeQuestionError);
  }
}
